// frontend/src/api/balance/balanceApi.js
import axiosClient from '../axiosClient';

export const balanceApi = {
  getBalances: async (page = 0, size = 20, search = '') => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });

      if (search && search.trim() !== '') {
        params.append('search', search.trim());
      }

      // axiosClient already returns response.data from the interceptor
      // So this will directly be: { balances: [...], currentPage: 0, ... }
      const data = await axiosClient.get(`/balance?${params.toString()}`);
      
      console.log('📦 Balance API data:', data);
      
      return data; // Return directly, don't access .data again
    } catch (error) {
      console.error('Error fetching balances:', error);
      throw error;
    }
  },

  exportBalances: async (search = '') => {
    try {
      const params = new URLSearchParams();
      
      if (search && search.trim() !== '') {
        params.append('search', search.trim());
      }

      // This returns an array directly
      const data = await axiosClient.get(`/balance/export?${params.toString()}`);
      return data;
    } catch (error) {
      console.error('Error exporting balances:', error);
      throw error;
    }
  },
   getSalesPersons: async () => {
    try {
      const data = await axiosClient.get('/balance/sales-persons');
      return data;
    } catch (error) {
      console.error('Error fetching sales persons:', error);
      throw error;
    }
  },

  getTopOutstanding: async (slpCode) => {
    try {
      const data = await axiosClient.get(`/balance/top-outstanding/${slpCode}`);
      return data;
    } catch (error) {
      console.error('Error fetching top outstanding:', error);
      throw error;
    }
  },
  

  getBalanceStats: async () => {
    try {
      const data = await axiosClient.get('/balance/stats');
      return data;
    } catch (error) {
      console.error('Error fetching balance stats:', error);
      throw error;
    }
  },
};